if (typeof ProductVariants !== "function") {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();

      // Властивості для підтримки 2000+ варіантів
      this._cachedOptions = new Map(); // Кеш завантажених комбінацій
      this._loadingOptions = new Set(); // Комбінації що завантажуються зараз
      this._debounceTimers = {}; // Таймери для debounce prefetch

      this.init();
    }

    init() {
      // ДІАГНОСТИКА: Перевіряємо скільки варіантів у продукту
      this.debugProductInfo();

      // КРИТИЧНО: Шукаємо в червоному блоці через атрибут [data-js-product-price-compact]
      // Це батьківський блок який містить snippet product-price.liquid
      const compactPriceBlock = document.querySelector('[data-js-product-price-compact]');

      if (compactPriceBlock) {
        console.log('[Variants] 📍 Знайдено червоний блок [data-js-product-price-compact]');

        // Шукаємо price елементи ВСЕРЕДИНІ червоного блоку
        this.priceOriginal = compactPriceBlock.querySelector("[data-js-product-price-original]");
        this.priceCompare = compactPriceBlock.querySelector("[data-js-product-price-compare]");
        this.priceUnit = compactPriceBlock.querySelector("[data-js-product-price-unit]");

        // Зберігаємо блок .product-price для сумісності
        this.price = compactPriceBlock.querySelector('.product-price') || compactPriceBlock;

        console.log('[Variants] ✅ Price елементи з червоного блоку:', {
          priceOriginal: this.priceOriginal,
          priceOriginalHTML: this.priceOriginal ? this.priceOriginal.innerHTML : 'ПОРОЖНЬО!',
          priceOriginalParent: this.priceOriginal ? this.priceOriginal.parentElement?.className : 'N/A'
        });
      } else {
        console.warn('[Variants] ⚠️ Червоний блок НЕ знайдено, використовуємо fallback...');

        // Fallback: старий спосіб
        this.price = document.querySelector(`#product-price-${this.dataset.id}`);

        if (this.price) {
          this.priceOriginal = this.price.querySelector("[data-js-product-price-original]");
          this.priceCompare = this.price.querySelector("[data-js-product-price-compare]");
          this.priceUnit = this.price.querySelector("[data-js-product-price-unit]");
        }
      }

      this.productForm = document.querySelector(
        `#product-form-${this.dataset.id}`
      );
      if (this.productForm) {
        this.productQty = this.productForm.querySelector(
          "[data-js-product-quantity]"
        );
        this.addToCart = this.productForm.querySelector(
          "[data-js-product-add-to-cart]"
        );
        this.addToCartText = this.productForm.querySelector(
          "[data-js-product-add-to-cart-text]"
        );
      }

      this.addEventListener("change", this.onVariantChange);
      let initVariantChange = false;

      if (this.hasAttribute("data-variant-required")) {
        this.variantRequired = true;
        this.noVariantSelectedYet = true;
        // НОВИЙ ПІДХІД: variant initialization через URL параметри
        // Не використовуємо getVariantData() - замість цього radio inputs вже встановлені
        if (document.location.search.includes("variant")) {
          initVariantChange = true;
          this.variantRequired = false;
          this.noVariantSelectedYet = false;
        }
      } else {
        this.variantRequired = false;
        this.noVariantSelectedYet = false;
      }

      this.updateOptions();
      this.updateMasterId();
      this.updateUnavailableVariants();

      this.productStock = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity]`
      );
      this.productStockProgress = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity-progress]`
      );
      if (
        this.productStock &&
        document.querySelector(
          `#product-${this.dataset.id} [data-js-variant-quantity-data]`
        )
      ) {
        this.productStockData = JSON.parse(
          document.querySelector(
            `#product-${this.dataset.id} [data-js-variant-quantity-data]`
          ).dataset.inventory
        );
      }
      this.updateStock();

      this._event = new Event("VARIANT_CHANGE");

      if (initVariantChange) {
        this.onVariantChange();
      }

      // Налаштовуємо обробники для custom drawer (тільки один раз)
      if (!this._drawerSetup) {
        this._drawerSetup = true;
        this.setupDrawerHandlers();
      }

      // КРИТИЧНО: Встановлюємо початкову ціну при завантаженні сторінки
      console.log('[Variants] 🔍 ДІАГНОСТИКА PRICE ЕЛЕМЕНТІВ:', {
        hasPrice: !!this.price,
        hasPriceOriginal: !!this.priceOriginal,
        priceOriginalHTML: this.priceOriginal ? this.priceOriginal.innerHTML : 'N/A',
        priceOriginalParent: this.priceOriginal ? this.priceOriginal.parentElement?.className : 'N/A',
        hasCurrentVariant: !!this.currentVariant,
        currentVariantPrice: this.currentVariant ? this.currentVariant.price : 'N/A'
      });

      if (this.currentVariant && this.priceOriginal) {
        console.log('[Variants] 🔄 Встановлюємо початкову ціну:', this.currentVariant.price);
        this.updatePrice();

        // ПЕРЕВІРКА: Чи оновилась ціна?
        console.log('[Variants] ✅ Після updatePrice():', this.priceOriginal.innerHTML);
      } else {
        console.warn('[Variants] ⚠️ Не можу встановити початкову ціну:', {
          hasCurrentVariant: !!this.currentVariant,
          hasPriceOriginal: !!this.priceOriginal
        });
      }
    }

    // Метод: Отримати хеш поточної комбінації опцій
    getCurrentOptionValuesHash() {
      const selectedIds = [];

      // ПРІОРИТЕТ #1: Checked radio inputs (найбільш надійний спосіб)
      const checkedRadios = this.querySelectorAll('input[type="radio"][data-option-value-id]:checked');
      console.log('[getCurrentOptionValuesHash] 🎯 Checked radio inputs:', checkedRadios.length);

      checkedRadios.forEach((radio) => {
        const optionValueId = radio.dataset.optionValueId;
        const colval = radio.dataset.colval || radio.value;
        console.log(`  ✓ Radio: ${colval} (id: ${optionValueId})`);
        selectedIds.push(optionValueId);
      });

      // FALLBACK: Якщо немає radio inputs, використовуємо hc-drawer-val-active
      if (selectedIds.length === 0) {
        console.log('[getCurrentOptionValuesHash] ⚠️ Немає checked radios, використовуємо drawer active');
        const activeDrawers = this.querySelectorAll('.hc-drawer-val-active[data-option-value-id]');

        activeDrawers.forEach((drawer) => {
          const optionValueId = drawer.dataset.optionValueId;
          const colval = drawer.dataset.colval;
          console.log(`  ✓ Drawer: ${colval} (id: ${optionValueId})`);
          selectedIds.push(optionValueId);
        });
      }

      const hash = selectedIds.join('-');
      console.log('[getCurrentOptionValuesHash] 📍 Результат хешу:', hash);
      return hash;
    }

    // Метод: Завантажити варіанти для конкретної комбінації опцій
    async fetchProductUpdates(optionValuesHash) {
      // Якщо вже завантажується - чекаємо
      if (this._loadingOptions.has(optionValuesHash)) {
        console.log(`[Variants] Вже завантажується: ${optionValuesHash}`);
        return null;
      }

      // Перевіряємо кеш
      if (this._cachedOptions.has(optionValuesHash)) {
        console.log(`[Variants] З кешу: ${optionValuesHash}`);
        return this._cachedOptions.get(optionValuesHash);
      }

      // Перевіряємо чи є необхідні атрибути
      if (!this.dataset.helperId || !this.dataset.url) {
        console.warn('[Variants] Відсутні data-helper-id або data-url');
        return null;
      }

      this._loadingOptions.add(optionValuesHash);

      try {
        // КЛЮЧОВИЙ ЗАПИТ: Section Rendering API з option_values
        const optionValuesParam = optionValuesHash.replace(/-/g, ',');
        const url = `${this.dataset.url}${this.dataset.url.includes('?') ? '&' : '?'}section_id=${this.dataset.helperId}&option_values=${optionValuesParam}`;

        console.log(`[Variants] 📡 ЗАПИТ до Helper Section:`);
        console.log(`  option_values: ${optionValuesParam}`);
        console.log(`  URL: ${url}`);

        const response = await fetch(url);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Зберігаємо в кеш
        this._cachedOptions.set(optionValuesHash, html);

        // Обмежуємо розмір кешу (макс 100 комбінацій)
        if (this._cachedOptions.size > 100) {
          const firstKey = this._cachedOptions.keys().next().value;
          this._cachedOptions.delete(firstKey);
          console.log('[Variants] Очищено старий кеш');
        }

        console.log(`[Variants] Завантажено: ${optionValuesHash}`);
        return html;

      } catch (error) {
        console.error('[Variants] Помилка завантаження:', error);
        return null;
      } finally {
        this._loadingOptions.delete(optionValuesHash);
      }
    }

    // Метод: Оновити доступність варіантів в UI
    async updateVariantAvailability() {
      // Запобігаємо повторному виклику під час виконання
      if (this._isUpdating) {
        console.log('[Variants] ⏸️ Вже оновлюється, пропускаємо...');
        return;
      }

      const hash = this.getCurrentOptionValuesHash();

      if (!hash) {
        console.log('[Variants] Немає вибраних опцій');
        return;
      }

      this._isUpdating = true;
      const startTime = performance.now();
      console.log('[Variants] 🔄 Початок оновлення варіанту...');

      // 🔒 КРИТИЧНО: Блокуємо кнопку ADD TO CART під час завантаження
      this.disableAddToCart();

      try {
        // Завантажуємо дані для цієї комбінації
        const fetchStart = performance.now();
        const html = await this.fetchProductUpdates(hash);
        console.log(`[Variants] ⏱️ Helper section завантажено за: ${(performance.now() - fetchStart).toFixed(0)}ms`);

        if (!html) return;

        // Отримуємо блок з інформацією про доступність
        const availabilityData = html.querySelector('[data-update-block="variant-availability"]');

        if (!availabilityData) {
          console.warn('[Variants] Не знайдено variant-availability блок');
          return;
        }

        // Оновлюємо доступність кожної опції
        const availableOptions = availabilityData.querySelectorAll('[data-option-value-id]');

        console.log(`[Variants] Оновлення доступності для ${availableOptions.length} опцій`);

        availableOptions.forEach(optionData => {
          const optionId = optionData.dataset.optionValueId;
          const isAvailable = optionData.dataset.available === 'true';

          // Знаходимо відповідні елементи в DOM
          const elements = this.querySelectorAll(`[data-option-value-id="${optionId}"]`);

          elements.forEach(element => {
            if (isAvailable) {
              element.removeAttribute('disabled');
              element.classList.remove('disabled', 'hc-drawer-val-unavailable');
            } else {
              element.setAttribute('disabled', 'disabled');
              element.classList.add('disabled', 'hc-drawer-val-unavailable');
            }
          });
        });

        // КРИТИЧНО: Знаходимо правильний варіант на основі вибраних опцій
        // Не можемо покладатися на helper section, бо він повертає завжди перший варіант
        const variant = await this.findVariantBySelectedOptions(availabilityData, html);

        if (variant) {
          console.log('[Variants] Поточний варіант:', variant.id);

          // Встановлюємо currentVariant для всієї теми
          this.currentVariant = variant;

          // Оновлюємо інфо через наш метод
          this.updateProductInfo(variant);
        } else {
          console.warn('[Variants] Не знайдено варіант для вибраної комбінації');
        }
      } catch (error) {
        console.error('[Variants] Помилка в updateVariantAvailability:', error);
      } finally {
        // 🔓 ЗАВЖДИ розблокуємо кнопку (навіть при помилці)
        this.enableAddToCart();
        this._isUpdating = false;
        const totalTime = performance.now() - startTime;
        console.log(`[Variants] ✅ Завершено оновлення варіанту за: ${totalTime.toFixed(0)}ms`);
      }
    }

    // Метод: Знайти варіант на основі вибраних option_value_id
    async findVariantBySelectedOptions(availabilityData, helperHtml) {
      // НОВИЙ ПІДХІД: Використовуємо selected_option_values з helper section
      // product.options_with_values.selected_value встановлюється автоматично!

      const selectedOptionIds = [];
      const selectedValues = [];

      // Спочатку пробуємо отримати selected_option_values з helper section
      if (helperHtml) {
        const variantDataScript = helperHtml.querySelector('[data-js-variant-data]');
        console.log('[Variants] variantDataScript знайдено:', !!variantDataScript);

        if (variantDataScript) {
          try {
            const variantData = JSON.parse(variantDataScript.textContent);
            console.log('[Variants] variantData:', variantData);

            // Перевіряємо чи є хоча б ОДНЕ непусте значення в selected_option_values
            const hasValidValues = variantData.selected_option_values &&
                                   variantData.selected_option_values.length > 0 &&
                                   variantData.selected_option_values.some(val => val && val.trim() !== '');

            console.log('[Variants] hasValidValues:', hasValidValues);

            if (hasValidValues) {
              console.log('[Variants] ✅ Отримано selected_option_values з helper section:', variantData.selected_option_values);

              // КРИТИЧНО: Перевіряємо чи є correct_variant_id (правильний ID для ПОВНОЇ комбінації)
              if (variantData.correct_variant_id) {
                console.log('[Variants] 🎯 ЗНАЙДЕНО correct_variant_id з helper section:', {
                  id: variantData.correct_variant_id,
                  price: variantData.correct_variant_price,
                  title: variantData.correct_variant_title,
                  available: variantData.correct_variant_available
                });

                // Повертаємо варіант напряму з helper section
                const variant = {
                  id: variantData.correct_variant_id,
                  title: variantData.correct_variant_title,
                  price: variantData.correct_variant_price,
                  available: variantData.correct_variant_available,
                  option1: variantData.selected_option_values[0],
                  option2: variantData.selected_option_values[1],
                  option3: variantData.selected_option_values[2]
                };

                this.updateURL(variant.id);
                return variant;
              }

              // Fallback: Використовуємо ці значення для пошуку варіанту (старий метод)
              const option1 = variantData.selected_option_values[0];
              const option2 = variantData.selected_option_values[1];
              const option3 = variantData.selected_option_values[2];

              console.log('[Variants] 🔍 Шукаємо варіант з комбінацією:', {option1, option2, option3});

              // Шукаємо варіант в Product JSON
              const url = `/products/${this.dataset.handle}.js`;
              const response = await fetch(url);
              const productData = await response.json();

              console.log(`[Variants] 📦 Всього варіантів в Product JSON: ${productData.variants.length}`);

              const variant = productData.variants.find(v =>
                v.option1 === option1 &&
                v.option2 === option2 &&
                (!option3 || v.option3 === option3)
              );

              if (variant) {
                console.log('[Variants] ✅ ЗНАЙДЕНО варіант:', {
                  id: variant.id,
                  title: variant.title,
                  option1: variant.option1,
                  option2: variant.option2,
                  option3: variant.option3,
                  price: variant.price,
                  priceFormatted: this._formatMoney(variant.price, KROWN.settings.shop_money_format)
                });

                // ⚡ ОПТИМІЗАЦІЯ: Оновлюємо URL і input[name="id"] ОДРАЗУ
                this.updateURL(variant.id);

                return variant;
              } else {
                console.warn('[Variants] ⚠️ Варіант не знайдено в Product JSON (>250)');

                // ШВИДКИЙ СПОСІБ: Шукаємо data-variant-id серед ВИБРАНИХ опцій
                // Якщо всі 3 опції мають data-selected, то одна з них ТОЧНО має правильний variant ID
                const selectedOptions = availabilityData.querySelectorAll('[data-selected][data-variant-id]');

                console.log('[Variants] Вибраних опцій з variant-id:', selectedOptions.length);

                // Якщо є хоча б одна вибрана опція з variant-id - беремо його
                let variantId = null;
                if (selectedOptions.length > 0) {
                  // Беремо ОСТАННЮ опцію (найбільш специфічна - Width/Height)
                  variantId = selectedOptions[selectedOptions.length - 1].dataset.variantId;
                  console.log('[Variants] ✅ Знайдено variant ID з data-selected:', variantId);
                }

                // Якщо не знайшли через data-selected - пробуємо старий метод
                if (!variantId) {
                  variantId = await this.findVariantIdFromAvailability(availabilityData, [option1, option2, option3]);
                }

                if (variantId) {
                  const basicVariant = {
                    id: variantId,
                    title: [option1, option2, option3].filter(Boolean).join(' / '),
                    option1,
                    option2,
                    option3,
                    available: true
                    // price: НЕ встановлюємо за замовчуванням!
                  };

                  // ⚡ ОПТИМІЗАЦІЯ: Оновлюємо URL ОДРАЗУ, не чекаючи ціну!
                  this.updateURL(variantId);

                  // Отримуємо ціну (асинхронно, не блокує URL)
                  const price = await this.fetchVariantPrice(variantId, helperHtml);
                  if (price && price > 0) {
                    basicVariant.price = price;
                    console.log('[Variants] ✅ Ціна отримана для варіанту >250:', price);
                  } else {
                    console.log('[Variants] ⚠️ Ціна НЕ отримана, залишаємо стару на екрані');
                  }

                  console.log('[Variants] ✅ Створено варіант для >250:', basicVariant);
                  return basicVariant;
                }
              }
            }
          } catch (error) {
            console.warn('[Variants] Помилка парсингу variant data:', error);
          }
        }
      }

      // Fallback: Якщо helper section не дав selected_option_values,
      // але є availabilityData - беремо значення звідти (НЕ з DOM!)
      console.warn('[Variants] Fallback: витягуємо опції з availabilityData');

      // Шукаємо ВИБРАНІ опції (data-selected) в availabilityData
      const selectedOptions = availabilityData.querySelectorAll('[data-selected][data-option-value-id]');

      console.log('[Variants] Знайдено вибраних опцій в availabilityData:', selectedOptions.length);

      selectedOptions.forEach((option, index) => {
        const optionValueId = option.dataset.optionValueId;
        const colval = option.dataset.colval || option.textContent.trim();

        console.log(`[Variants] Вибрана опція ${index + 1}:`, {
          colval,
          optionValueId
        });

        if (optionValueId && colval) {
          selectedOptionIds.push(optionValueId);
          selectedValues.push(colval);
        }
      });

      console.log('[Variants] Вибрані опції:', selectedValues);
      console.log('[Variants] Вибрані option_value_ids:', selectedOptionIds);

      if (selectedOptionIds.length === 0) {
        console.warn('[Variants] Не знайдено вибраних опцій варіантів');
        return null;
      }

      // КЛЮЧОВЕ РІШЕННЯ: Шукаємо в availabilityData елемент що має ВСІ вибрані option_value_ids
      // і має data-variant-id - це буде правильний варіант!
      let variantId = null;

      // Перевіряємо кожен option_value_id в availabilityData
      const allAvailabilityOptions = availabilityData.querySelectorAll('[data-option-value-id]');

      console.log('[Variants] Опцій в availabilityData:', allAvailabilityOptions.length);

      // Шукаємо опцію що має data-selected (вибрана) і data-variant-id
      let foundVariantIds = [];
      for (const optionData of allAvailabilityOptions) {
        const optionId = optionData.dataset.optionValueId;

        // Перевіряємо чи ця опція є серед вибраних
        if (selectedOptionIds.includes(optionId)) {
          const isSelected = optionData.hasAttribute('data-selected');
          const hasVariantId = !!optionData.dataset.variantId;

          console.log('[Variants] Знайдено вибрану опцію в availabilityData:', {
            optionId,
            hasVariantId: hasVariantId,
            variantId: optionData.dataset.variantId,
            isSelected: isSelected
          });

          // Якщо має data-variant-id - це потенційний варіант
          if (optionData.dataset.variantId) {
            foundVariantIds.push(optionData.dataset.variantId);

            // ПРІОРИТЕТ: Якщо це вибрана опція (data-selected) - використовуємо її варіант
            if (isSelected) {
              variantId = optionData.dataset.variantId;
              console.log('[Variants] ✅ Знайдено варіант через data-selected:', variantId);
              break; // Якщо знайшли з data-selected - це точно правильний
            }

            // Інакше зберігаємо як потенційний
            if (!variantId) {
              variantId = optionData.dataset.variantId;
              console.log('[Variants] Знайдено потенційний variant ID:', variantId);
            }
          }
        }
      }

      console.log('[Variants] Всі знайдені variant IDs:', foundVariantIds);

      if (!variantId) {
        console.warn('[Variants] ❌ Не знайдено variant ID в availabilityData');
        return null;
      }

      // Тепер завантажуємо деталі варіанту через Cart API
      try {
        const url = `/products/${this.dataset.handle}.js`;
        const response = await fetch(url);
        const productData = await response.json();

        const variant = productData.variants.find(v => v.id == variantId);

        if (variant) {
          console.log('[Variants] ✅ Знайдено варіант в Product JSON:', {
            id: variant.id,
            title: variant.title,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            price: variant.price,
            available: variant.available
          });

          // ⚡ ОПТИМІЗАЦІЯ: Оновлюємо URL і input[name="id"] ОДРАЗУ
          this.updateURL(variant.id);

          return variant;
        } else {
          // Якщо не знайдено в Product JSON (варіант >250)
          console.warn(`[Variants] ⚠️ Варіант ${variantId} не знайдено в Product JSON (це варіант >250)`);
          console.log('[Variants] Отримуємо дані варіанту через альтернативні методи...');

          // Створюємо базовий об'єкт варіанту з даних що ми вже маємо
          const basicVariant = {
            id: variantId,
            title: selectedValues.join(' / '),
            option1: selectedValues[0] || null,
            option2: selectedValues[1] || null,
            option3: selectedValues[2] || null,
            available: true, // Вже перевірено в availabilityData
            price: 0, // Ціну спробуємо отримати далі
            featured_image: null
          };

          console.log('[Variants] ✅ Створено базовий варіант:', basicVariant);

          // Пробуємо отримати ціну з різних джерел
          const price = await this.fetchVariantPrice(variantId, helperHtml);
          if (price) {
            basicVariant.price = price;
            console.log('[Variants] Ціну встановлено:', price);
          }

          return basicVariant;
        }
      } catch (error) {
        console.error('[Variants] Помилка завантаження варіанту:', error);
        return null;
      }
    }

    // Метод: Отримати ціну варіанту для >250 варіантів
    async fetchVariantPrice(variantId, helperHtml) {
      console.log('[Variants] Пошук ціни для варіанту:', variantId);

      // Спосіб 1: Використовуємо Variant JSON API - найточніший метод!
      try {
        const response = await fetch(`/variants/${variantId}.json`);
        if (response.ok) {
          const data = await response.json();
          console.log('[Variants] 🔍 Повна відповідь з API:', data.variant);

          if (data.variant && data.variant.price) {
            const priceString = data.variant.price;
            const price = parseInt(priceString);

            console.log('[Variants] ✅ Ціна з Variant JSON API:', {
              original: priceString,
              parsed: price,
              type: typeof price
            });

            return price;
          }
        }
      } catch (error) {
        console.warn('[Variants] Variant JSON API недоступний:', error);
      }

      // Спосіб 2: Перевіряємо чи є ціна в helper section response (не точний, але швидкий)
      try {
        if (helperHtml) {
          const priceBlock = helperHtml.querySelector('[data-update-block="price"]');

          if (priceBlock) {
            // Шукаємо ціну в HTML
            const priceElement = priceBlock.querySelector('[data-js-product-price-original]');

            if (priceElement) {
              // Витягуємо текст ціни і конвертуємо в число
              const priceText = priceElement.textContent.trim();
              console.log('[Variants] Знайдено ціну в helper section:', priceText);

              // Парсимо ціну (формат може бути: "€1.830,00" або "1830.00")
              const priceMatch = priceText.match(/[\d.,]+/);
              if (priceMatch) {
                // Конвертуємо в центи (Shopify зберігає ціни в центах)
                const priceString = priceMatch[0].replace(/[.,]/g, '');
                const price = parseInt(priceString);
                console.log('[Variants] ⚠️ Ціна з helper section (може бути не точна):', price);
                return price;
              }
            }
          }
        }
      } catch (error) {
        console.warn('[Variants] Не вдалося отримати ціну з helper section:', error);
      }

      // Спосіб 3: Fallback - використовуємо базову ціну продукту
      console.log('[Variants] ℹ️ Використовуємо базову ціну продукту (варіант >250).');

      try {
        const response = await fetch(`/products/${this.dataset.handle}.js`);
        const productData = await response.json();

        // Беремо ціну першого варіанту як базову
        if (productData.variants && productData.variants[0]) {
          const basePrice = productData.variants[0].price;
          console.log('[Variants] ℹ️ Використано базову ціну:', basePrice);
          return basePrice;
        }
      } catch (error) {
        console.error('[Variants] Помилка отримання базової ціни:', error);
      }

      return 0; // Якщо нічого не спрацювало
    }

    // Метод: Знайти variant ID з availabilityData для >250 варіантів
    async findVariantIdFromAvailability(availabilityData, selectedOptionValues) {
      console.log('[Variants] Пошук variant ID для опцій:', selectedOptionValues);

      // Збираємо всі data-variant-id з availabilityData що мають data-selected
      const allOptions = availabilityData.querySelectorAll('[data-variant-id]');
      const variantIds = new Set(); // Використовуємо Set щоб уникнути дублікатів

      allOptions.forEach(opt => {
        if (opt.dataset.variantId) {
          variantIds.add(opt.dataset.variantId);
        }
      });

      const variantIdsArray = Array.from(variantIds);
      console.log('[Variants] Знайдено унікальних variant IDs:', variantIdsArray.length);

      // ОПТИМІЗАЦІЯ: Перевіряємо варіанти ПАРАЛЕЛЬНО, а не послідовно!
      const promises = variantIdsArray.map(async (variantId) => {
        try {
          const response = await fetch(`/variants/${variantId}.json`);
          if (response.ok) {
            const data = await response.json();
            if (data.variant) {
              // Перевіряємо чи опції співпадають
              const matches =
                data.variant.option1 === selectedOptionValues[0] &&
                data.variant.option2 === selectedOptionValues[1] &&
                (!selectedOptionValues[2] || data.variant.option3 === selectedOptionValues[2]);

              if (matches) {
                return {id: variantId, variant: data.variant};
              }
            }
          }
        } catch (error) {
          console.warn(`[Variants] Помилка перевірки variant ${variantId}:`, error);
        }
        return null;
      });

      // Чекаємо ВСІ запити одночасно (замість послідовних)
      const results = await Promise.all(promises);

      // Знаходимо перший успішний результат
      const found = results.find(r => r !== null);

      if (found) {
        console.log('[Variants] ✅ Знайдено правильний variant ID:', found.id);
        return found.id;
      }

      console.warn('[Variants] ❌ Не вдалося знайти variant ID');
      return null;
    }

    // Метод: Заблокувати кнопку Add to Cart
    disableAddToCart() {
      if (this.addToCart) {
        this.addToCart.setAttribute('disabled', 'disabled');
        this.addToCart.classList.add('disabled', 'working');
        console.log('[Variants] 🔒 ADD TO CART заблоковано (working)');
      }
    }

    // Метод: Розблокувати кнопку Add to Cart
    enableAddToCart() {
      if (this.addToCart) {
        this.addToCart.removeAttribute('disabled');
        this.addToCart.classList.remove('disabled', 'working');
        console.log('[Variants] 🔓 ADD TO CART розблоковано');
      }
    }

    // Метод: Оновити URL з variant ID (швидкий, без чекання)
    updateURL(variantId) {
      if (!variantId) return;

      // Оновлюємо URL
      if (window.history && window.history.replaceState) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variantId));
          window.history.replaceState({path: url.toString()}, '', url.toString());
          console.log('[Variants] ⚡ URL оновлено (швидко):', variantId);
        } catch (error) {
          console.error('[Variants] Помилка оновлення URL:', error);
        }
      }

      // КРИТИЧНО: Оновлюємо input[name="id"] ОДРАЗУ для форми Add to Cart
      const variantIdInput = this.productForm?.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variantId;
        console.log('[Variants] ⚡ input[name="id"] оновлено:', variantId);
      } else {
        console.warn('[Variants] ⚠️ input[name="id"] не знайдено!');
      }

      // Також оновлюємо this.currentVariant.id для сумісності з іншим кодом
      if (this.currentVariant) {
        this.currentVariant.id = variantId;
      }
    }

    // Метод: Синхронізувати drawer UI з вибраними опціями
    syncDrawerUI(variant) {
      if (!variant) return;

      console.log('[Variants] 🔄 Синхронізація drawer UI з варіантом:', variant.title);

      // Знаходимо всі drawer блоки
      const drawers = this.querySelectorAll('.hc-drawer');

      drawers.forEach((drawer, index) => {
        const optionValue = variant[`option${index + 1}`];
        if (!optionValue) return;

        console.log(`  Опція ${index + 1}: ${optionValue}`);

        // Знімаємо active з усіх елементів в цьому drawer
        drawer.querySelectorAll('.hc-drawer-val-active').forEach(el => {
          el.classList.remove('hc-drawer-val-active');
        });

        // Знаходимо правильний елемент і додаємо active
        // Спочатку пробуємо точний збіг
        let correctOption = drawer.querySelector(`.hc-drawer-val[data-colval="${optionValue}"]`);

        // Якщо не знайдено, пробуємо з додаванням "cm" або інших варіантів
        if (!correctOption) {
          const allOptions = drawer.querySelectorAll('.hc-drawer-val[data-colval]');
          correctOption = Array.from(allOptions).find(el => {
            const colval = el.dataset.colval;
            // Перевіряємо різні формати: "280", "280cm", "280 cm", "280cm ", etc
            return colval === optionValue ||
                   colval === `${optionValue}cm` ||
                   colval === `${optionValue} cm` ||
                   colval.replace(/\s/g, '') === `${optionValue}cm` ||
                   colval.replace(/cm/gi, '').trim() === optionValue;
          });
        }

        if (correctOption) {
          correctOption.classList.add('hc-drawer-val-active');
          console.log(`  ✅ Оновлено drawer UI: ${optionValue}`);

          // Оновлюємо відображуване ім'я в UI
          const nameElement = drawer.querySelector('.product-variant__name, .col-name');
          if (nameElement) {
            const nameSpan = nameElement.querySelector('.col-size-value, span') || nameElement;
            nameSpan.textContent = correctOption.dataset.colval || optionValue;
          }
        } else {
          // Не критична помилка - просто не можемо синхронізувати UI
          console.log(`  ℹ️ Пропущено синхронізацію drawer UI для: ${optionValue} (елемент не знайдено)`);
        }
      });
    }

    // Метод: Оновити інформацію про продукт (ціна, наявність і т.д.)
    updateProductInfo(variant) {
      if (!variant) return;

      console.log('[Variants] 🔄 updateProductInfo викликано:', {
        variantId: variant.id,
        variantTitle: variant.title,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        price: variant.price,
        available: variant.available
      });

      // syncDrawerUI() ВІДКЛЮЧЕНО - product-option.js вже правильно керує активними класами
      // this.syncDrawerUI(variant);

      // Оновлюємо URL
      this.updateURL(variant.id);

      // Оновлюємо ціну ТІЛЬКИ якщо вона є (не очищуємо стару ціну)
      console.log('[Variants] 💰 Оновлення ціни:', {
        price: variant.price,
        hasPriceElement: !!this.priceOriginal,
        hasShopify: typeof Shopify !== 'undefined',
        hasFormatMoney: typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
      });

      // КРИТИЧНО: Оновлюємо ціну ТІЛЬКИ якщо variant.price існує (не null/undefined)
      // Перевіряємо typeof щоб відрізнити 0 (валідна ціна) від undefined (не завантажено)
      if (this.priceOriginal && typeof variant.price === 'number') {
        const moneyFormat = typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.shop_money_format
          ? KROWN.settings.shop_money_format
          : '{{amount_with_comma_separator}} €';

        this.priceOriginal.innerHTML = this._formatMoney(variant.price, moneyFormat);
        console.log('[Variants] ✅ Ціна оновлена:', this._formatMoney(variant.price, moneyFormat));
      } else {
        console.log('[Variants] ⚠️ Ціна НЕ оновлена (залишаємо стару):', {
          hasPriceElement: !!this.priceOriginal,
          priceType: typeof variant.price,
          priceValue: variant.price
        });
      }

      if (this.priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            this.priceCompare.innerHTML = `<span>${Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)}</span>`;
          }
        } else {
          this.priceCompare.innerHTML = '';
        }
      }

      // Оновлюємо input з ID варіанту
      const variantIdInput = this.productForm?.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      // Оновлюємо кнопку Add to Cart
      if (this.addToCart && this.addToCartText) {
        if (variant.available) {
          this.addToCart.removeAttribute('disabled');
          this.addToCart.classList.remove('disabled');
          if (this.productForm) {
            this.productForm.classList.remove('disabled-cart');
            this.productForm.classList.remove('unavailable-variant');
          }
          if (typeof KROWN !== 'undefined' && KROWN.settings?.locales?.products_add_to_cart_button) {
            this.addToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button;
          }
        } else {
          this.addToCart.setAttribute('disabled', 'disabled');
          this.addToCart.classList.add('disabled');
          if (this.productForm) {
            this.productForm.classList.add('disabled-cart');
          }
          if (typeof KROWN !== 'undefined' && KROWN.settings?.locales?.products_sold_out_variant) {
            this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
          }
        }
      }

      console.log('[Variants] Інфо оновлено:', {
        id: variant.id,
        price: variant.price,
        available: variant.available
      });
    }

    // Метод: Налаштувати обробники для custom drawer
    setupDrawerHandlers() {
      // НОВИЙ ПІДХІД: Замість обробки кліків на drawer, підписуємось на зміну radio inputs
      // Це дозволяє product-option.js обробити клік ПЕРШИМ і оновити radio inputs
      // А ми спрацьовуємо ПІСЛЯ того як radio input змінився

      console.log('[Variants] 🔧 Налаштування обробників на radio inputs...');

      // ВИДАЛЕНО: Тепер updateVariantAvailability() викликається через onVariantChange()
      // Це уникає race condition та подвійного виклику
      // addEventListener("change") → onVariantChange() → updateVariantAvailability()

      console.log(`[Variants] ✅ Обробники на ${this.querySelectorAll('input[type="radio"][data-option-value-id]').length} radio inputs налаштовано`);
    }

    // Метод: Отримати хеш якби ця опція була вибрана
    getHashIfOptionSelected(optionElement) {
      const optionId = optionElement.dataset.optionValueId;
      if (!optionId) return null;

      // Отримуємо всі вибрані опції
      const selectedInputs = this.querySelectorAll('[data-option-value-id]');
      const selectedIds = [];

      selectedInputs.forEach(input => {
        // Якщо це та опція над якою навели - додаємо її
        if (input === optionElement) {
          selectedIds.push(input.dataset.optionValueId);
          return;
        }

        // Інакше перевіряємо чи вибрана
        if (input.type === 'radio' && input.checked) {
          // Перевіряємо чи це не інша опція з того ж radio group
          if (optionElement.type === 'radio' && input.name === optionElement.name) {
            return; // Пропускаємо - ми замінимо її на optionElement
          }
          selectedIds.push(input.dataset.optionValueId);
        } else if (input.classList.contains('hc-drawer-val-active')) {
          selectedIds.push(input.dataset.optionValueId);
        }
      });

      return selectedIds.join('-');
    }

    async onVariantChange() {
      console.log('[onVariantChange] 🔄 Початок...');

      // КРИТИЧНО: Перевіряємо чи є підтримка >250 варіантів
      const hasHighVariantSupport = this.dataset.helperId && this.querySelector('[data-option-value-id]');

      if (hasHighVariantSupport) {
        console.log('[onVariantChange] ✅ Використовуємо НОВИЙ підхід (>250 варіантів)');

        // НОВИЙ ПІДХІД: Завантажуємо варіант через API і ДОЧІКУЄМОСЯ
        await this.updateVariantAvailability();

        // currentVariant вже встановлений через updateProductInfo() ✅
        // Оновлюємо тільки те що не конфліктує:
        this.updateVariantInput();
        this.updateStock(); // Оновлюємо stock інформацію
        this.updatePickupAvailability();
        if (!this.hasAttribute("data-no-history")) {
          this.updateURL();
        }
        this.updateDetails();
        this.updateVariantDetails(this.currentVariant);

      } else {
        console.log('[onVariantChange] ⚠️ Використовуємо СТАРИЙ підхід (≤250 варіантів)');

        // СТАРИЙ ПІДХІД: Для продуктів з ≤250 варіантів
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantInput();
        if (this.price) {
          this.updatePrice();
        }
        this.updateStock();
        this.updateUnavailableVariants();
        this.updatePickupAvailability();
        if (!this.hasAttribute("data-no-history")) {
          this.updateURL();
        }
        this.updateDetails();
        this.updateVariantDetails(this.currentVariant);
      }

      if (this.productForm) {
        if (!this.currentVariant || !this.currentVariant.available) {
          if (this.productQty) this.productQty.style.display = "none";
          this.addToCart.classList.add("disabled");
          this.productForm.classList.add("disabled-cart");
          this.addToCartText.textContent =
            KROWN.settings.locales.products_sold_out_variant;
        } else {
          if (this.productQty) this.productQty.style.display = "";
          this.addToCart.classList.remove("disabled");
          this.productForm.classList.remove("disabled-cart");
          this.addToCartText.textContent = this.hasAttribute(
            "data-show-bundle-wording"
          )
            ? KROWN.settings.locales.products_add_to_bundle_button
            : KROWN.settings.locales.products_add_to_cart_button;
        }
        if (!this.currentVariant) {
          this.productForm.classList.add("unavailable-variant");
          this.addToCartText.textContent =
            this.variantRequired && this.noVariantSelectedYet
              ? KROWN.settings.locales.products_variant_required
              : KROWN.settings.locales.products_unavailable_variant;
        } else {
          this.productForm.classList.remove("unavailable-variant");
        }
      }

      // Оновлюємо доступність варіантів для 2000+ підтримки
      // ТІЛЬКИ якщо це custom drawer (для radio buttons не треба)
      if (this.querySelector('.hc-drawer-val-active')) {
        // Вже оновлено через setupDrawerHandlers
      }

      this.dispatchEvent(this._event);
    }

    // ДІАГНОСТИКА: Перевірка інформації про продукт
    async debugProductInfo() {
      console.log('='.repeat(60));
      console.log('🔍 ДІАГНОСТИКА ПРОДУКТУ');
      console.log('='.repeat(60));

      const productHandle = this.dataset.handle;

      if (!productHandle) {
        console.error('❌ Немає data-handle атрибуту!');
        return;
      }

      console.log('📦 Product handle:', productHandle);

      try {
        // Завантажуємо Product JSON
        const response = await fetch(`/products/${productHandle}.js`);
        const productData = await response.json();

        console.log('📊 Product JSON Stats:');
        console.log('   • Назва:', productData.title);
        console.log('   • ID:', productData.id);
        console.log('   • Варіантів у JSON:', productData.variants.length);
        console.log('   • Опції:', productData.options);

        // Перевіряємо опції
        console.log('\n🎨 Перші 5 варіантів:');
        productData.variants.slice(0, 5).forEach((v, i) => {
          console.log(`   ${i + 1}. ${v.title} (ID: ${v.id})`);
          console.log(`      - option1: ${v.option1}`);
          console.log(`      - option2: ${v.option2}`);
          console.log(`      - option3: ${v.option3}`);
          console.log(`      - price: ${v.price}`);
          console.log(`      - available: ${v.available}`);
        });

        // Перевіряємо останні 5 варіантів
        if (productData.variants.length > 5) {
          console.log('\n🎨 Останні 5 варіантів:');
          productData.variants.slice(-5).forEach((v, i) => {
            console.log(`   ${productData.variants.length - 4 + i}. ${v.title} (ID: ${v.id})`);
            console.log(`      - option1: ${v.option1}`);
          });
        }

        // Перевіряємо унікальні значення опцій
        const uniqueOption1 = [...new Set(productData.variants.map(v => v.option1))];
        const uniqueOption2 = [...new Set(productData.variants.map(v => v.option2))];
        const uniqueOption3 = [...new Set(productData.variants.map(v => v.option3))];

        console.log('\n🎯 Унікальні значення опцій:');
        console.log(`   • Option 1 (${productData.options[0]}):`, uniqueOption1.length, 'значень');
        console.log(`     Приклади:`, uniqueOption1.slice(0, 5));
        console.log(`   • Option 2 (${productData.options[1]}):`, uniqueOption2.length, 'значень');
        console.log(`     Приклади:`, uniqueOption2.slice(0, 5));
        if (productData.options[2]) {
          console.log(`   • Option 3 (${productData.options[2]}):`, uniqueOption3.length, 'значень');
          console.log(`     Приклади:`, uniqueOption3.slice(0, 5));
        }

        console.log('\n📈 Теоретична кількість варіантів:');
        const theoretical = uniqueOption1.length * uniqueOption2.length * (uniqueOption3.length || 1);
        console.log(`   ${uniqueOption1.length} × ${uniqueOption2.length} × ${uniqueOption3.length || 1} = ${theoretical}`);

        if (productData.variants.length < theoretical) {
          console.warn(`   ⚠️ Product JSON містить тільки ${productData.variants.length} з ${theoretical} варіантів!`);
          console.warn(`   ⚠️ Це обмеження Shopify Product JSON API (250 варіантів)`);
          console.log(`   ℹ️ Для решти ${theoretical - productData.variants.length} варіантів використовуємо Section Rendering API`);
        }

        console.log('='.repeat(60));

      } catch (error) {
        console.error('❌ Помилка завантаження Product JSON:', error);
      }
    }

    updateVariantDetails(currentVariant) {
      // Check that currentVariant and currentVariant.id are defined
      if (!currentVariant || !currentVariant.id) {
        console.error("currentVariant or currentVariant.id is undefined");
        return;
      }

      // Hide all variant metafields
      const variantsMetafields = document.querySelectorAll(
        ".variant-metafields"
      );
      variantsMetafields.forEach(function (metafields) {
        metafields.style.display = "none";
      });

      // Show the selected variant's metafields
      const selectedMetafields = document.getElementById(
        "variant-metafields-" + currentVariant.id
      );
      if (selectedMetafields) {
        selectedMetafields.style.display = "flex";
      }
    }

    updateOptions() {
      this.options = [];

      this.querySelectorAll("[data-js-product-variant-container]").forEach(
        (elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                this.options.push(el.value);
              }
            });
          } else {
            if (!(this.variantRequired && elm.selectedIndex == 0)) {
              this.options.push(elm.value);
            }
          }
        }
      );

      if (
        this.variantRequired &&
        this.noVariantSelectedYet &&
        this.options.length >= parseInt(this.dataset.variants)
      ) {
        this.noVariantSelectedYet = false;
      }
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updatePrice() {
      if (!this.currentVariant) {
        if (!(this.variantRequired && this.noVariantSelectedYet)) {
          // НЕ ОЧИЩУЄМО ціну - просто нічого не робимо
          // this.priceOriginal.innerHTML = ""; // ЗАКОМЕНТОВАНО!
        }
      } else {
        // Оновлюємо ціну ТІЛЬКИ якщо є валідне значення
        if (this.currentVariant.price && this.currentVariant.price > 0 && this.priceOriginal) {
          this.priceOriginal.innerHTML = this._formatMoney(
            this.currentVariant.price,
            KROWN.settings.shop_money_format
          );
        }

        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          this.priceCompare.innerHTML = this._formatMoney(
            this.currentVariant.compare_at_price,
            KROWN.settings.shop_money_format
          );
        } else {
          this.priceCompare.innerHTML = "";
        }

        if (this.currentVariant.unit_price_measurement) {
          this.priceUnit.innerHTML = `
						${this._formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} /
						${
              this.currentVariant.unit_price_measurement.reference_value != 1
                ? this.currentVariant.unit_price_measurement.reference_value +
                  " "
                : ""
            }
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
        } else {
          this.priceUnit.innerHTML = "";
        }
      }
    }

    updateStock() {
      if (!this.currentVariant) {
        if (this.productStock) {
          this.productStock.innerHTML = "";
        }
      } else {
        if (this.productStock && this.productStockData) {
          let currentVariant = false;
          for (const variant of this.productStockData) {
            if (variant.id == this.currentVariant.id) {
              currentVariant = variant;
              break;
            }
          }
          this.productStock.innerHTML = "";

          if (currentVariant) {
            if (currentVariant.quantity <= 0) {
              if (currentVariant.inventory == "continue") {
                this.productStock.innerHTML =
                  KROWN.settings.locales.products_preorder;
              } else if (currentVariant.inventory == "deny") {
                this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products;
              }
            } else if (currentVariant.quantity == "1") {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_one_product;
            } else if (
              currentVariant.quantity <=
              parseInt(this.productStock.dataset.lowStock)
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (currentVariant.unavailable) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_no_products;
            } else if (
              currentVariant.quantity >
                parseInt(this.productStock.dataset.lowStock) &&
              this.productStock.dataset.type == "always"
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (!currentVariant.quantity) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_enough_products;
            }

            if (this.productStockProgress) {
              let progressQty = 0;
              if (
                (currentVariant.quantity <= 0 &&
                  currentVariant.inventory == "continue") ||
                typeof currentVariant.quantity === "undefined"
              ) {
                progressQty = parseInt(this.productStock.dataset.highStock);
              } else if (currentVariant.quantity > 0) {
                progressQty = currentVariant.quantity;
              }
              if (
                progressQty >= parseInt(this.productStock.dataset.highStock)
              ) {
                this.productStockProgress.style.width = `100%`;
              } else {
                this.productStockProgress.style.width = `${
                  (100 * progressQty) /
                  parseInt(this.productStock.dataset.highStock)
                }%`;
              }
            }
          }
        }
      }
    }

    updateDetails() {
      document
        .querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`)
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.sku) {
            elm.innerHTML =
              KROWN.settings.locales.product_sku + this.currentVariant.sku;
          } else {
            elm.innerHTML = "";
          }
        });

      document
        .querySelectorAll(
          `#product-${this.dataset.id} [data-js-product-barcode]`
        )
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.barcode) {
            elm.innerHTML =
              KROWN.settings.locales.product_barcode +
              this.currentVariant.barcode;
          } else {
            elm.innerHTML = "";
          }
        });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    updateUnavailableVariants() {
      if (this.dataset.hideVariants != "false") {
        let options1 = {},
          options2 = {},
          options3 = {},
          option1Selected = null,
          option2Selected = null;

        if (this.dataset.variants > 1) {
          option1Selected = this._getSelectedOption(0);
          this._resetDisabledOption(1);
        }
        if (this.dataset.variants > 2) {
          option2Selected = this._getSelectedOption(1);
          this._resetDisabledOption(2);
        }

        this.getVariantData().forEach((el) => {
          if (this.dataset.variants > 0) {
            if (!options1[el.option1]) {
              options1[el.option1] = [];
            }
            options1[el.option1].push(String(el.available));
          }
          if (this.dataset.variants > 1) {
            if (!options2[el.option2]) {
              options2[el.option2] = [];
            }
            options2[el.option2].push(String(el.available));
          }
          if (this.dataset.variants == 2) {
            if (el.option1 == option1Selected && !el.available) {
              this._setDisabledOption(1, el.option2);
            }
          }
          if (this.dataset.variants > 2) {
            if (!options3[el.option3]) {
              options3[el.option3] = [];
            }
            options3[el.option3].push(String(el.available));
            if (
              el.option2 == option2Selected &&
              el.option1 == option1Selected &&
              !el.available
            ) {
              this._setDisabledOption(2, el.option3);
            }
          }
        });

        if (this.dataset.variants > 0) {
          Object.keys(options1).forEach((key) => {
            if (!options1[key].includes("true")) {
              this._setDisabledOption(0, key);
            }
          });
        }
        if (this.dataset.variants > 1) {
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              this._setDisabledOption(1, key);
            }
          });
        }
        if (this.dataset.variants > 2) {
          Object.keys(options3).forEach((key) => {
            if (!options3[key].includes("true")) {
              this._setDisabledOption(2, key);
            }
          });
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              if (option2Selected == key) {
                if (this.dataset.hideVariants == "disable") {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .setAttribute("disabled", "disabled");
                } else {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .classList.add("disabled");
                }
              }
            }
          });
        }
      }
    }

    _getSelectedOption(i) {
      let selectedOption = null;
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll("[data-js-product-variant-container]")
        .forEach((elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                selectedOption = el.value;
              }
            });
          } else {
            selectedOption = elm.value;
          }
        });
      return selectedOption;
    }

    _resetDisabledOption(i) {
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll(".product-variant-value")
        .forEach((elm) => {
          elm.classList.remove("disabled");
          elm.classList.remove("hide-variant");
          if (!elm.hasAttribute("default")) {
            elm.removeAttribute("disabled");
          }
          elm.parentNode.classList.remove("hide-variant");
        });
    }

    _setDisabledOption(i, option) {
      let variant = this.querySelectorAll("[data-js-product-variant]")[
        i
      ].querySelector(
        `.product-variant-value[value="${option.replace('"', "&x22;")}"]`
      );
      if (variant) {
        if (this.dataset.hideVariants == "disable") {
          variant.setAttribute("disabled", "disabled");
        } else if (this.dataset.hideVariants == "true") {
          variant.classList.add("disabled");
        } else if (this.dataset.hideVariants == "hide") {
          if (
            this.querySelectorAll("[data-js-product-variant]")[i].querySelector(
              "[data-js-product-variant-container]"
            ).dataset.jsProductVariantContainer == "radio"
          ) {
            variant.parentNode.classList.add("hide-variant");
          } else {
            variant.classList.add("hide-variant");
          }
        }
      }
    }

    updateURL() {
      if (!this.currentVariant) return;
      const urlParams = new URLSearchParams(window.location.search);     

      if (urlParams.has('epoxy')) {
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}&epoxy=${urlParams.get('epoxy')}`
        );
      } else {
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }      
    }

    updateVariantInput() {
      if (!this.currentVariant) return;
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-variants") == "undefined") {
    customElements.define("product-variants", ProductVariants);
  }
}

/* ---
	Product Form
--- */

if (typeof ProductForm !== "function") {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.cartType = this.hasAttribute("data-ajax-cart") ? "ajax" : "page";
      if (
        !document.body.classList.contains("template-cart") ||
        this.hasAttribute("data-force-form")
      ) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }
      // if (document.body.classList.contains("touchevents")) {
      //   const submitButton = this.querySelector('[type="submit"]');
      //   if (submitButton) {
      //     submitButton.addEventListener("touchstart", (e) => {
      //       submitButton.click();
      //     });
      //   }
      // }
    }

    onSubmitHandler(e) {
      e.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.classList.add("working");

      const body = this._serializeForm(this.form);
      let alert = "";

      fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        body,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        method: "POST",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.className = "alert alert--error";
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
            if (this.cartType == "page") {
              if (
                document.getElementById("product-page-form-error-cart-alert")
              ) {
                document
                  .getElementById("product-page-form-error-cart-alert")
                  .remove();
              }
              alert.style.marginTop = "1em";
              alert.style.marginBottom = "0";
              alert.id = "product-page-form-error-cart-alert";
              this.form.parentElement.append(alert);
              return false;
            }
            
return fetch('/cart.js')
  .then(res => res.json())
  .then(async cart => {
    for (const item of cart.items) {
      try {
        const res = await fetch(`/products/${item.handle}.js`);
        const product = await res.json();
        if (product.tags.includes('delete')) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
      } catch (err) {
        console.error('Помилка при видаленні товару з тегом delete:', err);
      }
    }
    return fetch("?section_id=helper-cart");
  });

          } else {
            if (this.cartType == "page") {
              document.location.href = KROWN.settings.routes.cart_url;
              return false;
            } else {
              
return fetch('/cart.js')
  .then(res => res.json())
  .then(async cart => {
    for (const item of cart.items) {
      try {
        const res = await fetch(`/products/${item.handle}.js`);
        const product = await res.json();
        if (product.tags.includes('delete')) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
      } catch (err) {
        console.error('Помилка при видаленні товару з тегом delete:', err);
      }
    }
    return fetch("?section_id=helper-cart");
  });

            }
          }
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          if (alert != "") {
            document
              .getElementById("AjaxCartForm")
              .querySelector("form")
              .prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-count]"
              ).textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-total]"
              ).textContent;
            });
          this.dispatchEvent(this.ADD_TO_CART);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          submitButton.classList.remove("working");
        });
    }

    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    }
  }

  if (typeof customElements.get("product-form") == "undefined") {
    customElements.define("product-form", ProductForm);
  }
}

/* ---
	Product Recommendations
--- */

if (typeof ProductRecommendations !== "function") {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const event = new Event("product-recommendations-loaded");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const innerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("product-recommendations");

            if (
              innerHTML &&
              innerHTML.querySelectorAll("[data-js-product-item]").length > 0
            ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll("form").forEach((elm) => {
                if (elm.querySelector("template")) {
                  elm.append(
                    elm.querySelector("template").content.cloneNode(true)
                  );
                }
              });
              this.dispatchEvent(event);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: `0px 0px 400px 0px`,
      }).observe(this);
    }
  }

  if (typeof customElements.get("product-recommendations") == "undefined") {
    customElements.define("product-recommendations", ProductRecommendations);
  }
}

/* ---
	Gift card recipent
--- */

if (typeof GiftCardRecipient !== "function") {
  class GiftCardRecipient extends HTMLElement {
    constructor() {
      super();

      const properties = Array.from(
        this.querySelectorAll('[name*="properties"]')
      );
      const checkboxPropertyName =
        "properties[__shopify_send_gift_card_to_recipient]";

      this.recipientCheckbox = properties.find(
        (input) => input.name === checkboxPropertyName
      );
      this.recipientOtherProperties = properties.filter(
        (input) => input.name !== checkboxPropertyName
      );
      this.recipientFieldsContainer = this.querySelector(
        ".gift-card-recipient__fields"
      );

      this.recipientCheckbox?.addEventListener(
        "change",
        this.synchronizeProperties.bind(this)
      );
      this.synchronizeProperties();
    }

    synchronizeProperties() {
      this.recipientOtherProperties.forEach(
        (property) => (property.disabled = !this.recipientCheckbox.checked)
      );
      this.recipientFieldsContainer.classList.toggle(
        "hide",
        !this.recipientCheckbox.checked
      );
    }
  }

  if (typeof customElements.get("gift-card-recipient") == "undefined") {
    customElements.define("gift-card-recipient", GiftCardRecipient);
  }
}
